import { createContext, Dispatch, SetStateAction } from 'react'

import { HouseOwnerHouseFieldFragment } from '@/lib/graphql'

export interface HValidation {
  house: HouseOwnerHouseFieldFragment | undefined
  setHouse: Dispatch<SetStateAction<HouseOwnerHouseFieldFragment | undefined>>
}

export const HouseContext = createContext<HValidation>({} as HValidation)
